module.exports = __webpack_public_path__ + "img/280.d3ced8bf.jpg";